<template lang="pug">
section.single
  Header
  .container
    .box
      .header.text-center.mb-5.pb-3
        h1.title パスワードのリセット

      ValidationObserver(slim,ref="observer",v-slot="{ invalid }")
        b-form(ref="form",@submit.prevent)
          b-form-group(label="",label-for="input-email",description="",required)
            ValidationProvider(rules="required|email",name="メールアドレス",v-slot="{ errors }")
              b-form-input#input-email(ref="input-email",v-model="email",type="text",required,placeholder="登録済みのメールアドレスを入力してください",@input="checkInput",:state="!email ? null : email && errors.length === 0")
              //-.form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

        .text-center.mt-5
          b-button(pill,variant="primary",@click="onSend()",:disabled="!valid && !changed")
            // i.fas.fa-save
            span パスワードのリセットURLを送信する

          p.mt-4
            a(href="/")
              span トップページ
  Footer
</template>

<script>
import { postData } from '../utils/api'

const page = {
  id: 'resetPassword',
  title: 'パスワードリセット'
}

export default {
  data () {
    return {
      mask: false,
      page: page,
      email: null,
      sent: false
    }
  },
  methods: {
    async checkInput () {
      this.valid = await this.$refs.observer.validate()
      return this.valid
    },
    onSend () {
      this.msgBoxConfirm('パスワードのリセットURLを送信しますか？', this.doSend)
    },
    async doSend () {
      this.mask = true

      let message

      await postData('/resetPassword', {
        email: this.email
      }).then(async (json) => {
        this.$bvModal.msgBoxOk('パスワードのリセットメールを送信しました')
        this.email = null
      }).catch((err) => {
        console.error(err)

        message = 'パスワードのリセットメールの送信が失敗しました'

        if (err.response && err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        if (message === 'Not Found Data') {
          message = '入力されたメールアドレスは未登録（または未認証）です'
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
